import React from 'react'
import appUrl from "../../../../constants/appUrl";
const ViewAttachement = ({attachment}) => {
  return (
    <img src={`${appUrl.baseUrl}${attachment}`} style={{ width: '100%', height: '300px' }} alt="Attachment" />
  )
}

export default ViewAttachement